import styled from '@emotion/styled'

export const StyleWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`

export const StyleBox = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid
    ${(props) =>
      props.theme.colors[props.isSelected ? 'primary' : 'inputBorder']};
  border-radius: 6px;
  padding: 15px 10px;
  align-items: center;
  cursor: pointer;
`

export const StyleContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 15px;
  align-items: center;
`

export const StyleText = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.primaryTextColor100};
`
